// extracted by mini-css-extract-plugin
module.exports = {"search_box":"searchbox_search_box__3JcUT","search_icon":"searchbox_search_icon__2lNVJ","arrow":"searchbox_arrow__2larb"};